module.exports = __webpack_public_path__ + "img/hairong.b396a78e.jpg";